import {NewsVendor, vendorShortName} from "../../types/NewsVendors";

export const NewsVendorPipe = "tfNewsVendorName";

export function newsVendorPipe() {
    return (vendor: NewsVendor | null) => {
        if (vendor == null) {
            return null;
        } else {
            return vendorShortName(vendor);
        }
    };
}
